export const PRICE_VALUE_LIST = [
  {
    name: "$0.00 - $200k",
    id: "0.00-200000.00",
  },
  {
    name: "$200k - $400k",
    id: "200000.00-400000.00",
  },
  {
    name: "$400k - $600k",
    id: "400000.00-600000.00",
  },
  {
    name: "$600k - $800k",
    id: "600000.00-800000.00",
  },
  {
    name: "$800k - $1M",
    id: "800000.00-1000000.00",
  },
  {
    name: "$1M - $2M",
    id: "1000000.00-2000000.00",
  },
  {
    name: "$2M - $4M",
    id: "2000000.00-4000000.00",
  },
  {
    name: "$4M - $6M",
    id: "4000000.00-6000000.00",
  },
  {
    name: "$6M - $8M",
    id: "6000000.00-8000000.00",
  },
  {
    name: "$8M - $10M",
    id: "8000000.00-10000000.00",
  },
  {
    name: "$10M - Above",
    id: "10000000.00-100000000000.00",
  },
];


// Define enum for modules
export enum ModuleListViewType {
  CRM = 'crm',
  CONTACTS = 'contacts',
  CONTRACTS = 'contracts',
  SUBSCRIPTIONS = 'subscriptions',
  INVOICE = 'invoice',
  EXPLORE_LEADS = "leads",
  // Add more modules as required
}

export  const ACTIVITY_BG = {
  TODAY: "#e99d00",
  OVERDUE: "#d44c59",
  PLANNED: "#28a745",
};

export  const SUBSCRIPTIONS_USER_STATUS = {
  ACTIVE: 1,
  UNSUBSCRIBED: 2
};